import { useState, useEffect, useRef } from 'react';
import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';

const TypingTextElement = ({ element }) => {
  const { replaceTemplates } = useOnboarding();
  const [displayedText, setDisplayedText] = useState('');
  const style = applyStyles(element);
  const timeoutRef = useRef(null);

  useEffect(() => {
    // Clear any existing animation
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    
    // Reset displayed text
    setDisplayedText('');
    
    // Get text and validate it's not undefined/null
    const text = replaceTemplates(element.text) || '';
    if (!text) return;
    
    const duration = element.animationDuration || 2000;
    const chars = text.split('');
    const charDelay = duration / chars.length;
    let currentIndex = 0;

    const typeChar = () => {
      if (currentIndex < chars.length) {
        const char = chars[currentIndex];
        setDisplayedText(prev => prev + char);
        currentIndex++;
        timeoutRef.current = setTimeout(typeChar, charDelay);
      }
    };

    timeoutRef.current = setTimeout(typeChar, 100);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [element.text, element.animationDuration, replaceTemplates]);

  return (
    <div className="element-typing-text" style={style}>
      <span className="typing-text-content">{displayedText}</span>
      <span className="typing-cursor">|</span>
    </div>
  );
};

export default TypingTextElement;

